module.exports = __webpack_public_path__ + "img/email-preview.4c0db440.png";